<template>
  <div
      :class="{ 'panel-card': isOpenDetailSection }"
      class="widget-inner p-0 expand-icon details-panel"
      @click.stop="toggleDetailSection">
    <div class="details-content py-8 px-16">
      <panel-heading
          :is-open="isOpenDetailSection"
          title="Details"
          left-icon="details"
          right-icon="chevron"/>
    </div>
    <div
        v-show="isOpenDetailSection"
        class="bm-collapse Details panel-card-body"
        @click.stop="stopPropagation">
      <div class="panel-field-label">Title</div>
      <text-field
          :value="productName"
          :number="false"
          label="Product title"
          class="hide-label"/>

      <div class="panel-field-label">Page size</div>
      <Product-Page-Size v-if="isOpenDetailSection"/>
      <div class="d-flex align-items-center dimensions-select">
        <text-field
            :value="getSelectedPageWidth"
            :second-value="getSelectedPageHeight"
            :number="isNumberField"
            :is-inch="isInch"
            :is-product-size-ratio="isProductSizeRatio"
            label="Width"
            class="hide-label input-prefix"
            data-prefix="W"/>
        <div
            v-tooltip="isProductSizeRatio ? 'Unlock ratio' : 'Lock ratio'"
            :class="{ active: isProductSizeRatio }"
            class="panel-icon-btn"
            @click="toggleProductSizeRatioFlag">
          <icon :name="isProductSizeRatio ? 'constraints-proportion-icon' : 'constraints-proportion-iconOFF'"/>
        </div>
        <text-field
            :value="getSelectedPageHeight"
            :second-value="getSelectedPageWidth"
            :number="isNumberField"
            :is-inch="isInch"
            :is-product-size-ratio="isProductSizeRatio"
            label="Height"
            class="hide-label input-prefix"
            data-prefix="H"/>
        <div
            ref="detailsDropdown"
            :class="[isDropdownShown ? 'show-content' : '']"
            class="dropdown-panel d-flex justify-content-between align-items-center position-relative unit-select"
            @click="showSelectionDropDown($event)">
          <span class="selected-font">{{ productSize.selectedUnit === 'Inches' ? 'in' : 'px' }}</span>
          <span class="custom-icon">
            <icon name="chevron"/>
          </span>
          <ul class="dropdown-selection list-unstyled mb-0 position-absolute w-100 bg-white d-none">
            <li
                class="selection py-6"
                @click="selected($event)">{{ productSize.otherUnit }}
            </li>
          </ul>
        </div>
        <div
            v-tooltip="'Save as favourite size'"
            class="panel-icon-btn bordered"
            @click="showFavouriteSizeInModel">
          <icon :name="'star-un-favourite'"/>
        </div>
      </div>
      <div v-if="$store.getters['activeProduct/getIsVideoMoodOn']" data-dc-tpl="87" style="display: flex; gap: 8px; padding: 9px 10px; background: rgb(255, 246, 229); border: 1px solid rgb(245, 217, 168); border-radius: 8px; font-size: 12px; line-height: 1.45; color: rgb(122, 74, 0); text-wrap: pretty; margin-top: 12px;">If you change the size of this page, all other pages will be adjusted to match the new dimensions. This might cause the overall design to change.</div>
      <div class="panel-field-label">View &amp; export</div>

      <div class="panel-toggle-group">
        <utility-buttons-panel
            id="1"
            :is-toggled="isGrayScaleOn"
            label="Grayscale PDF:"
            title="Grayscale PDF"/>
        <utility-buttons-panel
            id="2"
            :is-toggled="isSnappingEnabled"
            label="Alignment Guides:"
            title="Alignment guides"/>
        <utility-buttons-panel
            v-if="1"
            id="3"
            :is-toggled="isRulerOn"
            label="Show Rulers:"
            title="Show rulers"/>
        <utility-buttons-panel
            id="3"
            :is-toggled="isVideoMoodOn"
            :is-same-dimension-pages="checkProductPagesAreInSameDimension"
            :product-has-video-audio-animation="productHasVideoAudioAnimation"
            label="Video Mode:"
            title="Video mode"/>
        <utility-buttons-panel
            v-if="isProductCrop.isShowCrop"
            id="3"
            :is-toggled="!isProductCrop.allowCrop"
            label="Crop Marks"
            title="Crop marks"/>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import PanelHeading from '@/components/PanelHeading/PanelHeading';
import TextField from '@/components/TextField/TextField';
import UtilityButtonsPanel from '@/components/UtiltyButtonsPanel/UtiltyButtonsPanel';
import ProductPageSize from '@/components/ProductPageSize/ProductPageSize';

export default {
  name:       'DetailsPanel',
  components: {
    'panel-heading':         PanelHeading,
    'text-field':            TextField,
    'utility-buttons-panel': UtilityButtonsPanel,
    'Product-Page-Size':     ProductPageSize,
  },
  props: {
    product:             { type: Object, default: null },
    productName:         { type: String, default: '' },
    productSize:         { type: Object, default: () => ({}) },
    isOpenDetailSection: { type: Boolean, default: false },
    isProductSizeRatio:  { type: Boolean, default: false },
    isInch:              { type: Boolean, default: false },
    isProductCrop:       { type: Object, default: () => ({}) },
    isGrayScaleOn:       { type: Boolean, default: false },
    isAlignmentGuideOn:  { type: Boolean, default: true },
    isRulerOn:           { type: Boolean, default: false },

    productHasVideoAudioAnimation: {
      type:    Boolean,
      default: false,
    },
  },
  data() {
    return {
      isNumberField:   true,
      isDropdownShown: false,
      selectedOption:  'Pixels',
      valuechange:     'Inches',
    };
  },
  computed: {
    checkProductPagesAreInSameDimension() {
      let same = true;
      if (!this.product) {
        same = true;
      }
      if (this.product) {
        this.product.pages.forEach((page, i) => {
          if (i > 0) {
            if (this.product.pages[i - 1].width !== page.width) {
              console.log('widths not same');
              same = false;
            }
            if (this.product.pages[i - 1].height !== page.height) {
              console.log('heights not same');
              same = false;
            }
          }
        });
      }
      return same;
    },
    isVideoMoodOn() {
      return this.product && this.$store.getters['activeProduct/getIsVideoMoodOn'];
    },
    isSnappingEnabled() {
      return this.isAlignmentGuideOn;
    },
    getSelectedPageWidth() {
      return this.productSize.width;
    },
    getSelectedPageHeight() {
      return this.productSize.height;
    },
  },
  methods: {
    showFavouriteSizeInModel() {
      EventBus.$emit(ApplicationEventTypes.ModalEvents.SHOW_SIZE_MODAL, {
        height: this.productSize.height,
        width:  this.productSize.width,
        unit:   this.productSize.selectedUnit,
      });
    },
    toggleProductSizeRatioFlag() {
      EventBus.$emit('pauseVideoOnOutsideClick');
      EventBus.$emit('toggleProductSizeRatioFlag');
    },
    stopPropagation() {
    },
    toggleDetailSection() {
      EventBus.$emit('pauseVideoOnOutsideClick');
      this.$emit('OpenDetailSection');
    },
    showSelectionDropDown() {
      this.isDropdownShown = !this.isDropdownShown;
    },
    // Called by LeftSection's EventBus 'modalsCloser' listener.
    onmodalClose({ checkModal, e }) {
      try {
        if (this.isDropdownShown === true) {
          checkModal = true;
        }
        if (e && !(this.$refs.detailsDropdown.contains(e.target))) {
          this.isDropdownShown = false;
        }
      } catch (ex) {
        console.log(ex.message);
      }
    },
    selected(e) {
      const temp          = this.selectedOption;
      this.selectedOption = e.target.innerText;
      this.valuechange    = temp;
      EventBus.$emit('updateProductSize', e.target.innerText);
      this.$store.commit('setIsUnitInInch', e.target.innerText == 'Inches');
    },
  },
};
</script>
